import { IVersesMemo } from 'components/common/Modals/memosModal/interfaces';
import { INote } from 'types';

import type { INormalizedChapters, VerseRowRecord } from './types';

export const isSameVerseMemo = (a: IVersesMemo, b: IVersesMemo) => a.verseNumber === b.verseNumber && a.translationId === b.translationId;

export const hasNoteForVerse = (notes: INote[], bookNumber: number, chapterNumber: number, verseIndex: number): boolean => notes.some(
  n => n.verseIndex === verseIndex && n.bookNumber === bookNumber && n.chapterNumber === chapterNumber,
);

export function getTableData(readingData: INormalizedChapters): VerseRowRecord[] {
  return readingData.versesRows
    .map((row, rowIndex) => {
      const hasText = row.some(cell => Boolean(cell.text));
      const record: VerseRowRecord = {
        key: rowIndex,
        verse: rowIndex,
      };

      row.forEach((cell, columnIndex) => {
        record[`translation${columnIndex}`] = cell;
      });

      return hasText ? record : null;
    })
    .filter((row): row is VerseRowRecord => row !== null);
}
